import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteDataContext = createContext({
    ready: false,
    siteContent: {},
    practiceAreas: [],
    faqs: [],
    contactInfo: null,
    blogPosts: [],
    error: null,
});

export function SiteDataProvider({ children }) {
    const [state, setState] = useState({
        ready: false,
        siteContent: {},
        practiceAreas: [],
        faqs: [],
        contactInfo: null,
        blogPosts: [],
        error: null,
    });

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const [sc, pa, fq, ci, bp] = await Promise.all([
                    api.get("/site-content"),
                    api.get("/practice-areas"),
                    api.get("/faqs"),
                    api.get("/contact-info"),
                    api.get("/blog-posts"),
                ]);
                if (cancelled) return;
                setState({
                    ready: true,
                    siteContent: sc.data || {},
                    practiceAreas: pa.data || [],
                    faqs: fq.data || [],
                    contactInfo: ci.data || null,
                    blogPosts: bp.data || [],
                    error: null,
                });
            } catch (err) {
                if (cancelled) return;
                setState((s) => ({
                    ...s,
                    ready: true,
                    error: err?.message || "network_error",
                }));
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <SiteDataContext.Provider value={state}>
            {children}
        </SiteDataContext.Provider>
    );
}

export function useSiteData() {
    return useContext(SiteDataContext);
}
